import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AdmissionFormComponent } from 'src/app/view/admission/admission-form/admission-form.component';
import { AdmissionProcessComponent } from 'src/app/view/admission/admission-process/admission-process.component';
import { AdmissionComponent } from 'src/app/view/admission/admission.component';
import { FeeComponent } from 'src/app/view/admission/fee/fee.component';
import { SharedModule } from '../shared/shared.module';
import { RouterModule } from '@angular/router';



@NgModule({
  declarations: [
    AdmissionComponent,
    AdmissionProcessComponent,
    AdmissionFormComponent,
    FeeComponent,
  ],
  imports: [
    CommonModule,
    RouterModule.forChild([
      {path:'',component:AdmissionComponent,children: [
        {path:'admission-process',component:AdmissionProcessComponent},
        {path:'admission-form',component:AdmissionFormComponent},
        {path:'fee',component:FeeComponent},
        // {path:'online-admission',component:OnlineAdmissionComponent},
      ]}
    ]),
    SharedModule
  ]
})
export class AdmissionModule { }
